import type { CustomField, CustomFieldSettingsMap } from '$lib/model/custom-fields';
import { writable } from 'svelte/store';

export let customFieldStore = writable<CustomField<keyof CustomFieldSettingsMap>[]>([]);
export let customFieldFormContext = writable<{
	attachToCustomer: boolean;
}>({ attachToCustomer: false });

export function copyCustomField(
	customField: CustomField<keyof CustomFieldSettingsMap>
): CustomField<keyof CustomFieldSettingsMap> {
	return JSON.parse(JSON.stringify(customField));
}

export function loadCustomFieldsFromData(data: CustomField<keyof CustomFieldSettingsMap>[]) {
	customFieldStore.set(data);
}
